<template>
    <div class="container">
        <div class="about-banner">
            <img src="../../assets/images/fx1.png" />
            <p class="title">{{ t('sharec.bannertitle') }}</p>
        </div>
        <div class="navigation-bar">
            <div class="navigation-bar-txt">
                <span><router-link to="/">{{ t('menu.home') }}</router-link></span>
                <span>{{ t('menu.sharingcenter') }}</span>
            </div>
        </div>
        <div class="new-list-bar">
            <div class="news-list">
                <div class="left-list">
                    <h3>{{ t('sharec.moduleA.title') }}</h3>
                    <p class="subtitle">Q：{{ t('sharec.moduleA.q') }}</p>
                    <p class="content">A：{{ t('sharec.moduleA.a') }}</p>
                </div>
                <div class="right-list">
                    <img class="fr" src="../../assets/images/fx6.png" />
                </div>
            </div>
        </div>
        <div class="new-list-bar">
            <div class="news-list">
                <div class="right-list">
                    <img class="fl" src="../../assets/images/fx3.png" />
                </div>
                <div class="left-list">
                    <h3>{{ t('sharec.moduleB.title') }}</h3>
                    <p class="subtitle">Q：{{ t('sharec.moduleB.q') }}</p>
                    <p class="content">A：{{ t('sharec.moduleB.a') }}</p>
                    <ul class="ul-list">
                        <li v-for="item in t('sharec.moduleB.list').split(';')" :key="item">
                            <i class="li-icon"></i><span class="span-txt">{{ item }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="new-list-bar">
            <div class="news-list">
                <div class="left-list">
                    <div class="left-list">
                    <h3>{{ t('sharec.moduleC.title') }}</h3>
                    <p class="subtitle">Q：{{ t('sharec.moduleC.q') }}</p>
                    <p class="content">A：{{ t('sharec.moduleC.a') }}</p>
                </div>
                </div>
                <div class="right-list">
                    <img class="fr" src="../../assets/images/fx4.png" />
                </div>
            </div>
        </div>
        <div class="new-list-bar">
            <div class="news-list">
                <div class="right-list">
                    <img class="fl" src="../../assets/images/fx5.png" />
                </div>
                <div class="left-list">
                    <h3>{{ t('sharec.moduleD.title') }}</h3>
                    <p class="subtitle">Q：{{ t('sharec.moduleD.q') }}</p>
                    <p class="content">A：{{ t('sharec.moduleD.a') }}</p>
                </div>
            </div>
        </div>
        <div class="new-list-bar">
            <div class="news-list">
                <div class="left-list">
                    <h3>{{ t('sharec.moduleE.title') }}</h3>
                    <p class="content">A：{{ t('sharec.moduleE.q') }}</p>
                    <ul class="ul-list">
                        <li v-for="item in t('sharec.moduleE.a').split(';')" :key="item">
                            <i class="li-icon"></i><span class="span-txt">{{ item }}</span>
                        </li>
                    </ul>
                </div>
                <div class="right-list">
                    <img class="fr" src="../../assets/images/fx6.png" />
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import {watch} from "vue";
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()
watch(locale, (newValue) => {
  if (newValue === 'zh') {
    console.log('当前语言为中文')
  } else if (newValue === 'en') {
    console.log('当前语言为英文')
  }
}, { immediate: true })


</script>
<style lang="scss" scoped>
.about-banner {
    width: 100%;
    position: relative;

    img {
        display: block;
        width: 100%;
    }

    p {
        width: 800px;
        position: absolute;
        text-align: center;
        left: 50%;
        margin-left: -400px;
        color: #fff;
    }

    .title {
        top: 190px;
        font-size: 40px;
        font-weight:600;
        letter-spacing:1px;
    }


}

.news-list {
    justify-items: center;
    justify-content: center;

    .left-list {
        flex: 1.4;
        padding: 10px 60px 60px 0px;

        h3 {
            margin: 20px auto;
            font-size: 32px;
        }
        .subtitle{
            font-size: 20px;
            text-align: left;
        }
        .content{
            margin-top:20px;
            font-size: 16px;
            line-height: 32px;
            text-align: left;
        }
        .ul-list {
            display: flex;
            flex-direction: column;
            margin-top:20px;
            li {
                display: flex;
                flex-direction: row;

                .li-icon {
                    display: block;
                    width: 24px;
                    height: 24px;
                    background: url('../../assets/images/li-icon.svg') no-repeat left 6px;
                }

                .span-txt {
                    margin-left: 10px;
                    flex: 1;
                    display: block;
                    line-height: 32px;
                    font-size: 16px;
                }
            }
        }
    }

    .right-list {
        flex: 2;
        border: 4px;

        img {
            width: 80%;
            box-sizing: border-box;
            border: 2px solid #d9d9d9;
        }
    }
}
</style>